export const ATTEMPT = 'cimb/ATTEMPT';
export const CONFIRM = 'cimb/CONFIRM';
export const REJECT = 'cimb/REJECT';
export const SUCCESS = 'cimb/SUCCESS';
export const FREEZE_CASH_IN_PRICE = 'cimb/FREEZE_CASH_IN_PRICE';

export const attemptToCashIn = (price, betId, slipId) => ({
  type: ATTEMPT,
  price,
  betId,
  slipId
});

export const freezeCashInPrice = (price) => ({
  type: FREEZE_CASH_IN_PRICE,
  price
});

export const confirm = () => ({
  type: CONFIRM
});

export const reject = () => ({
  type: REJECT
});

export const success = (betId, betDelay) => ({
  type: SUCCESS,
  betId,
  betDelay
});
